export const DOCUMENT_LANGUAGES = [{ value: "es", label: "Español" }, { value: "zh", label: "中文（简体） · Chino simplificado" }, { value: "es-zh", label: "Español + 中文" }];
export const normalizeDocumentLanguage = (value) => DOCUMENT_LANGUAGES.some((option) => option.value === value) ? value : "es";
const chinese = {
  "Fecha": "日期",
  "ALBARÁN": "送货单",
  "Albarán": "送货单",
  "Proceso": "工序",
  "Familia": "产品类别",
  "Proveedor": "供应商",
  "Sin asignar": "未指定",
  "Cantidad": "数量",
  "Precio": "单价",
  "Sin definir": "未设置",
  "Observaciones": "备注",
  "Notas S/O": "生产子订单备注",
  "Escanea para comunicar\nla devolución": "扫描二维码填写返还数量",
  "Cantidades enviadas y casillas para anotar la devolución": "已发数量及返还数量填写栏",
  "Color": "颜色",
  "Total": "合计",
  "Devolución": "返还数量",
  "prendas": "件",
  "consumo/prenda": "每件用量",
  "Material": "材料",
  "Cons./prenda": "每件用量",
  "Merma %": "损耗率 %",
  "Total cant.": "总数量",
  "Sin referencia": "无参考编号",
  "Ref.": "编号",
  "Colores de materiales por lote / variante": "各批次／款式的材料颜色",
  "Color del lote / variante": "批次／款式颜色",
  "Color del material": "材料颜色",
  "Prendas": "件数",
  "Sin color": "无颜色",
  "Color pendiente": "颜色待确认",
  "Color del lote": "批次颜色",
  "Contrastes del lote": "批次配色",
  "Talla / color del lote": "尺码／批次颜色",
  "Corte": "裁剪",
  "Devol.": "返还",
  "TOTAL PRENDAS": "总件数",
  "Material / proveedor": "材料／供应商",
  "Total general": "总计",
  "TOTAL GENERAL": "总计",
  "TOTAL HOJA": "本页合计",
  "Necesidad = prendas del color x consumo por prenda, sin merma. C1/C2/C3: contrastes del lote (tabla superior).": "所需用量 = 该颜色件数 × 每件用量，不含损耗。C1/C2/C3：批次配色（见上表）。",
  "Cada material indica su color asignado. Color pendiente: revisar antes de preparar el tejido.": "每种材料均标明指定颜色。颜色待确认：备料前请核实。",
  "Sin materiales asociados.": "无关联材料。",
  "1. Prendas a cortar y devolución por color": "1. 按颜色列出的裁剪件数及返还数量",
  "2. Material necesario por color del lote": "2. 各批次颜色所需材料",
  "Devolución de prendas": "成衣返还",
  "Actualizar formulario": "刷新表单",
  "Actualizar borra las cantidades sin enviar; revisa todos los colores.": "刷新将清除尚未提交的数量；请检查所有颜色。",
  "Procesando…": "处理中…",
  "Las cantidades ya se han comunicado. Este formulario está cerrado. Para corregirlas, contacta con quien te envió el albarán.": "数量已提交，本表单已关闭。如需更正，请联系送货单发送方。",
  "Introduce las cantidades totales que devuelves. Todas las casillas empiezan en 0. Cambia solo las tallas de las que devuelves prendas; las que dejes vacías se guardarán como 0. Solo podrás enviar el formulario una vez.": "请填写本次返还的总数量。所有输入框初始值为0。只需修改有返还成衣的尺码；空白将按0保存。本表单只能提交一次。",
  "Sin descripción": "无描述",
  "Sin color configurado": "未设置颜色",
  "Talla": "尺码",
  "Enviadas": "已发数量",
  "He revisado todos los colores y tallas. Confirmo que esta es la devolución completa.": "我已核对所有颜色和尺码，确认这是本次全部返还数量。",
  "Confirmar y enviar devolución": "确认并提交返还数量",
  "Color de la fila": "行颜色",
  "Fila": "行",
  "No se pudo completar la operación. Actualiza el formulario o contacta con quien te envió el albarán.": "操作未完成。请刷新表单或联系送货单发送方。"
};
export function manufacturingTranslator(language = "es") {
  const normalized = normalizeDocumentLanguage(language);
  return (text) => normalized === "es" || !chinese[text] ? text : normalized === "zh" ? chinese[text] : `${text} / ${chinese[text]}`;
}
export function localizedReturnUrl(value, language) {
  const url = new URL(value);
  url.searchParams.set("lang", normalizeDocumentLanguage(language));
  return url.href;
}
